import { FieldInputProps } from "react-final-form";

import { Switch } from "@livechat/design-system-react-components";

import { EventPlace, trackEngagement } from "helpers/analytics";

interface IProps {
  input: FieldInputProps<string | boolean, HTMLElement>;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const LogoSwitch = ({ input }: IProps) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  function handleChange(event: any) {
    input.onChange(event);
    if (input.checked) {
      trackEngagement("Visual template editor: Appearance logo hidden", EventPlace.Settings);
    }
  }

  return <Switch on={input.checked} onChange={handleChange} data-testid="switch-ShowLogo" />;
};
